module.exports = __webpack_public_path__ + "static/media/globe.4cccd039.png";